import { NgModule } from "@angular/core";
import { AbasModule } from "./abas/abas.module";
import { OperacaoDetalheComponent } from "./operacao-detalhe.component";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    declarations:[
        OperacaoDetalheComponent
    ],
    imports:[
        AbasModule,
        NgbNavModule
    ]
})
export class DetalheModule {}